import React from 'react'

const AllocationMessage = () => {
  return (
    <p className="text-primary mdi mdi-alert-circle-outline" style={{ marginBottom: '8px' }}>
      This item is on allocation and quantity may be limited
    </p>
  )
}

export default AllocationMessage
